import { Eyebrow } from "@/components/Eyebrow";
import { Reveal } from "@/components/Reveal";
import { Mark } from "@/components/Mark";

const VIDEOS = [
  { src: "/videos/femdacia-busqueda.mp4", label: "Búsqueda Google", offset: "md:mt-0" },
  { src: "/videos/femdacia-dia3.mp4", label: "Día 3 — Vístete de autenticidad", offset: "md:mt-16" },
  { src: "/videos/femdacia-dia5.mp4", label: "Día 5 — Todas tenemos historias que contar", offset: "md:mt-8" },
  { src: "/videos/femdacia-esencia.mp4", label: "Sin tendencia, solo esencia", offset: "md:mt-24" },
];

export default function Femdacia() {
  return (
    <section
      data-testid="femdacia-section"
      className="border-t border-mirian-wine/15 px-6 py-28 md:px-12 md:py-40 lg:px-20"
    >
      <div className="mx-auto max-w-6xl">
        <Eyebrow index="06" label="Trabajo real · Femdácia" />
        <Reveal delay={0.1}>
          <h2 className="mt-10 max-w-3xl font-serif text-4xl leading-[1.1] sm:text-5xl">
            No todo lo que he hecho empezó en un PowerPoint.
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 max-w-xl space-y-5 text-base leading-relaxed text-mirian-wine/75">
            <p>
              Femdácia fue un proyecto real en el que pude trabajar el marketing
              desde dentro: desde la construcción de la identidad y el mensaje
              de marca hasta su ejecución en contenido digital.
            </p>
            <p>
              La idea no era simplemente enseñar camisetas. Buscaba construir un
              territorio alrededor de la autenticidad, la libertad y la
              expresión personal, y trasladarlo después a diferentes piezas y
              formatos.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="mt-16 font-serif text-3xl uppercase leading-tight tracking-wide sm:text-4xl">
            De la idea a la ejecución.
          </p>
          <p className="mt-4 text-xs uppercase leading-loose tracking-[0.18em] text-mirian-wine/50">
            Estrategia de contenido · Concepto creativo · Copy · Diseño · Reels
            · Social media
          </p>
        </Reveal>

        <div
          data-testid="femdacia-videos"
          className="mt-16 grid grid-cols-2 gap-4 md:mt-20 md:grid-cols-4 md:gap-6"
        >
          {VIDEOS.map((v, i) => (
            <Reveal key={v.src} delay={i * 0.12} y={24} className={v.offset}>
              <figure>
                <video
                  data-testid={`femdacia-video-${i + 1}`}
                  src={v.src}
                  controls
                  playsInline
                  preload="metadata"
                  className="aspect-[9/16] h-auto w-full bg-mirian-wine/5"
                />
                <figcaption className="mt-3 text-xs uppercase tracking-[0.18em] text-mirian-wine/50">
                  {v.label}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p className="mt-20 max-w-3xl font-serif text-2xl leading-snug sm:text-3xl lg:text-4xl">
            Fue ahí donde aprendí algo que sigo aplicando hoy: una marca puede
            tener muchas piezas, pero todas deberían parecer parte de{" "}
            <Mark delay={0.5}>la misma conversación</Mark>.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
